import axios from 'axios';
import React, { useEffect, useState } from 'react'

export default function FilterOrder({ data, setResult }) {
    const [users, setUsers] = useState("");
    const [datas, setDatas] = useState("");
    useEffect(() => {
        axios.get(`http://${process.env.REACT_APP_API_URL}/users/search-all`, {
            headers: {
                Bearer: localStorage.getItem('token')
            }
        }).then((response) => {
            // console.log(response);
            if (response.status === 200) {
                setUsers(response.data);
            }
        }
        ).catch((error) => {
            if (error.response.data.status === 401) {
                window.location.href = "/auth/login";
            }
            console.log(error);
        });
    }, [])

    const handleData = (e) => {
        setDatas({ ...datas, [e.target.name]: e.target.value })

    }

    useEffect(() => {

        if (datas.status && datas.sales) {
            const result = data?.filter(x => x.status?.includes(datas.status) && x.sales?.includes(datas.sales))
            setResult(result)

        } else if (datas.status) {
            const result = data?.filter(x => x.status?.includes(datas.status))
            setResult(result)

        } else if (datas.sales) {
            const result = data?.filter(x => x.sales?.includes(datas.sales))
            setResult(result)

        } else {
            setResult(data)
        }
    }
        , [datas])

    return (
        <>
            <div className='flex orderbar'>
                <p style={{ fontWeight: "bold", marginRight: "10px", alignSelf: "center" }}>Filter</p>
                <div className='flex'>
                    <div className='mr-2' >
                        <select name="status" id="status" className="rounded" onChange={handleData}>
                            <option value="">เลือกสถานะ</option>
                            <option value="Opened" >Opened</option>
                            <option value="Cancelled" >Cancelled</option>
                            <option value="Shipping" >Shipping</option>
                            <option value="Waiting Return" >Waiting Return</option>
                            <option value="Completed" >Completed</option>
                            <option value="Claim" >Claim</option>
                            <option value="Return" >Return</option>
                            <option value="Lost" >Lost</option>
                        </select>
                    </div>
                    <div >
                        <select name="sales" id="sales" className="rounded" onChange={handleData}>
                            <option value="">เลือกSales</option>
                            {users && users.map((user, index) => (
                                <option key={index} value={user.username}>{user.username}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </>

    )
}
